<mat-dialog-content>
  <form [formGroup]="icaBaseForm">
    <div class="row">
      <div class="col-md-4">
        <span>{{ 'City' | translate }}:</span>
        <select class="form-control" formControlName="city">
          <option selected value="">{{ 'Select city' | translate }}</option>
          @for (city of citiesList; track city) {
            <option [ngValue]="city">
              {{ city.name }}
            </option>
          }
        </select>
        @if (textValid('city')) {
          <span class="form-text text-danger">{{
            'You must select a city' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span>{{ 'Type' | translate }}:</span>
        <select class="form-control" formControlName="id_type">
          <option selected value="">{{ 'Select type' | translate }}</option>
          @for (type of typesList; track type.id_type) {
            <option [ngValue]="type.id_type">
              {{ type.description }}
            </option>
          }
        </select>
        @if (textValid('id_type')) {
          <span class="form-text text-danger">{{
            'You must select a type' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span>UVT:</span>
        <input
          class="form-control"
          type="number"
          placeholder="UVT"
          formControlName="uvt"
        />
        @if (textValid('uvt')) {
          <span class="form-text text-danger">{{
            'tributary.common.uvtRequired' | translate
          }}</span>
        }
      </div>
    </div>
    <div class="row dialog-actions">
      <div class="col action-button">
        <button (click)="register()" mat-raised-button>
          {{ 'Register' | translate }}
        </button>
      </div>
      <div class="col action-button">
        <button mat-raised-button [mat-dialog-close]>
          {{ 'Cancel' | translate }}
        </button>
      </div>
    </div>
  </form>
</mat-dialog-content>

<ngx-spinner
  type="ball-scale-multiple"
  template="<img src='../../../../../../assets/gif/V1-Insight-Icon-for-gif-2.gif' />"
  bdColor="rgba(51,51,51,0.8)"
>
  <p class="spinner-message">{{ 'Loading...' | translate }}</p>
</ngx-spinner>
